import React from 'react';
import { Col, Row } from "antd";
import { ParagraphHeader } from "@seims/shared";

export const BackgroundView = () => {
  return (
    <div>
      <Row>
        <Col xs={24}>
          <ParagraphHeader header="What is SEIMS?" />
          <Row className="justift-text" style={{ justifyContent: "center" }}>
            <Col sm={22} md={20}>
              {/* <div className="nys-initiative-img">
                    <Image height={400} xs={24} md={6} src={require("../assets/NYS-initiative.jpg")} />
                  </div> */}
              <div className="public-portal-section-text">
                <p>
                  The Department of Science and Innovation (DSTI), which also provides policy and strategic leadership for the programme,
                  is the primary funder of the science engagement programme.
                  The programme's main objective is to create a society that is both science-literate and science-aware.
                  The programme is implemented through multiple projects or initiatives run by different stakeholders and role players.</p>
                <p>To store and process raw project performance data, these stakeholders and role players upload it to the Science Engagement Information
                  Management System (SEIMS), a central database. SEIMS aligns the science engagement programme with the 2011 National Evaluation Policy
                  Framework of the Department of Performance Monitoring and Evaluation and the 2007 Framework for Managing Programme Performance Information
                  of the National Treasury. Explore SEIMS and discover more about its features, including the analytics dashboard, document repository,
                  and ways to enhance the science engagement programme by contributing pertinent data to the SEIMS.
                </p>
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  )
}
